import ct from 'countries-and-timezones'
import railsTimezone from 'rails-timezone'

import { centralTimeDayJs } from '@shared/constants/time-zone'
import i18n from '@shared/i18n'

const getDateOfTheMonth = (
  month: number,
  dayOfWeek: number,
  countPerMonth?: number
) => {
  const date = new Date(new Date().getFullYear(), month, 1, 12)
  const year = date.getFullYear()
  const allDaysInMonth = getAllDaysInMonth(year, month, dayOfWeek)

  const selectedDay =
    countPerMonth !== undefined
      ? allDaysInMonth[countPerMonth]
      : allDaysInMonth[allDaysInMonth.length - 1]

  date.setDate(selectedDay)

  return date
}

const getAllDaysInMonth = (
  year: number,
  month: number,
  dayOfWeek: number
): Array<number> => {
  const selectedDays: Array<number> = []
  let day = 1
  let date = new Date(year, month, day)

  while (date.getMonth() === month) {
    const currentDay = date.getDay()

    if (currentDay === dayOfWeek) {
      selectedDays.push(date.getDate())
    }

    day += 1
    date = new Date(year, month, day)
  }

  return selectedDays
}

const isDateBetweenTwoDates = (
  fromDate: Date,
  toDate: Date,
  givenDate: Date
) => {
  return givenDate <= toDate && givenDate >= fromDate
}

export const isCDT = (givenDate: string): boolean => {
  const fromDate = getDateOfTheMonth(2, 0, 1)
  const toDate = getDateOfTheMonth(10, 0, 0)

  return isDateBetweenTwoDates(fromDate, toDate, new Date(givenDate))
}

export const getTimezoneWithDefault = (timezone?: string): string => {
  return timezone
    ? (railsTimezone.from(timezone) ?? timezone)
    : centralTimeDayJs
}

export const timezoneUsMapper = (timezone: string, isDaylightTime: boolean) => {
  switch (timezone) {
    case 'Hawaii':
    case 'Alaska':
    case 'Arizona':
      return timezone
    case 'Pacific Time (US & Canada)':
      return isDaylightTime
        ? i18n.global.t('usTimezone.pacificDaylight')
        : i18n.global.t('usTimezone.pacific')
    case 'Mountain Time (US & Canada)':
      return isDaylightTime
        ? i18n.global.t('usTimezone.mountainDaylight')
        : i18n.global.t('usTimezone.mountain')
    case 'Central Time (US & Canada)':
      return isDaylightTime
        ? i18n.global.t('usTimezone.centralDaylight')
        : i18n.global.t('usTimezone.central')
    case 'Eastern Time (US & Canada)':
      return isDaylightTime
        ? i18n.global.t('usTimezone.easternDaylight')
        : i18n.global.t('usTimezone.eastern')
    default:
      return isDaylightTime
        ? i18n.global.t('usTimezone.centralDaylight')
        : i18n.global.t('usTimezone.central')
  }
}

export const isValidTimezone = (timezone: string) => {
  return Object.keys(ct.getAllTimezones()).includes(timezone)
}
